import { IComponentOptions } from "angular";
import { LookupEditModalController } from "./controller";

export const vsComponentName = "lookupEditModal";

export const lookupEditModalComponentOptions: IComponentOptions = {
  controller: LookupEditModalController,
  controllerAs: "componentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    resolve: "<",
    modalInstance: "<",
  },
};
